import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '@shared/services/loading/loading.service';

/**
 * HTTP Interceptor that automatically shows/hides loading indicator for HTTP requests
 * 
 * To skip loading for specific requests, add a custom header:
 * headers: { 'X-Skip-Loading': 'true' }
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);

    // Check if this request should skip loading
    const skipLoading = req.headers.has('X-Skip-Loading');

    if (skipLoading) {
        // Remove the custom header before sending the request
        const cleanReq = req.clone({
            headers: req.headers.delete('X-Skip-Loading')
        });
        return next(cleanReq);
    }

    // Generate a unique key for this request
    const requestKey = `http-${req.method}-${req.url}-${Date.now()}`;

    // Show loading
    loadingService.show(requestKey);

    // Handle the request and hide loading when complete
    return next(req).pipe(
        finalize(() => {
            loadingService.hide(requestKey);
        })
    );
};
